import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Box } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';

// images
import patientMobile5En from "../assets/image/tutorial/patient/mobile/patientTutorial5-en.png";
import patientDesktop5En from "../assets/image/tutorial/patient/desktop/patientTutorial5-en.png";
import patientDesktop5Bm from "../assets/image/tutorial/patient/desktop/patientTutorial5-bm.png";
import tutorialArrow from "../assets/image/tutorialArrow.png";

const PatientTutorial5 = ({ language }) => {

    const navigate = useNavigate();
    const { t } = useTranslation();

    const [openTutorial, setOpenTutorial] = useState(true);

    return (
        <div>
            {
                isMobile ? (
                    <img src={patientMobile5En} alt="patientTutorial" style={{ height: "100vh", width: "100vw" }} />
                ) : (
                    <img src={language === "bm" ? patientDesktop5Bm : patientDesktop5En} alt="patientTutorial" style={{ height: "100vh", width: "100vw" }} />
                )
            }
            <Modal
                open={openTutorial}
                onClose={() => setOpenTutorial(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                hideBackdrop={true}
            >
                <Box className="tutorial-modal-4">
                    <p style={{ fontSize: "18px" }}>{t("Contact our hotline or read the FAQs here")}</p>
                    <img src={tutorialArrow} alt="arrow" style={{ float: "right" }} onClick={() => navigate('/patient/patientHome')} />
                </Box>
            </Modal>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        language: state.patient.language
    };
};

export default connect(mapStateToProps, null)(PatientTutorial5);
